import styled from 'styled-components';
import { COLORS } from '../../../../constants/radar';

export const TreeContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
`;

export const TreeItem = styled.div`
  padding-left: ${props => props.level * 20}px;
  border-radius: 4px;
  background-color: ${props => props.isSelected ? `${COLORS.PRIMARY}10` : 'transparent'};
  position: relative;
`;

export const TagName = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 8px;
  cursor: pointer;
  color: ${COLORS.PRIMARY};
  font-weight: 500;
`;

export const TagIcon = styled.span`
  color: ${COLORS.SECONDARY};
  display: flex;
  align-items: center;
`;

export const TagCount = styled.span`
  font-size: 12px;
  color: ${COLORS.SECONDARY};
  margin-left: 4px;
`;

export const TagActions = styled.div`
  display: ${props => props.$show ? 'flex' : 'none'};
  gap: 8px;
  margin-left: 8px;
`;

export const ActionButton = styled.button`
  background: none;
  border: none;
  cursor: pointer;
  color: ${COLORS.SECONDARY};
  padding: 4px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 4px;

  &:hover {
    background-color: ${COLORS.BACKGROUND};
    
    &.delete {
      color: #dc3545;
    }
  }
`;

export const ChildrenContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
  margin-top: 4px;
`; 